<template>
  <v-col cols="12">
    <v-data-table
      :headers="headers"
      :items="contactPersons"
      sort-by="id"
      class="elevation-1"
    >
      <template #top>
        <v-toolbar flat>
          <v-toolbar-title>Ansprechpartner</v-toolbar-title>
          <v-divider class="mx-4" inset vertical />
          <v-spacer />
          <v-dialog v-model="dialog" max-width="800px">
            <template #activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                Ansprechpartner hinzufügen
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-tabs
                  v-model="editTab"
                  color="primary"
                  slider-color="primary"
                >
                  <v-tab ripple>
                    Daten
                  </v-tab>
                  <v-tab v-if="editedIndex != -1 && $page.props.user.permissions.offer.admin_view" ripple>
                    Verknüpfungen
                  </v-tab>
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="2">
                              <v-select
                                v-model="contactPersonForm.form_of_address"
                                :items="[
                                  { text: 'Herr', value: 'Mr.' },
                                  { text: 'Frau', value: 'Mrs.' },
                                  { text: 'keine Angabe', value: 'Mx.' },
                                ]"
                                item-value="value"
                                item-text="text"
                                label="Anrede"
                              />
                            </v-col>
                            <v-col cols="5">
                              <v-text-field
                                v-model="contactPersonForm.first_name"
                                :error-messages="
                                  contactPersonForm.errors.first_name
                                "
                                label="Vorname"
                              />
                            </v-col>
                            <v-col cols="5">
                              <v-text-field
                                v-model="contactPersonForm.last_name"
                                :error-messages="
                                  contactPersonForm.errors.last_name
                                "
                                label="Nachname"
                              />
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model="contactPersonForm.notice"
                                :error-messages="contactPersonForm.errors.notice"
                                label="Anmerkung"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                v-model="contactPersonForm.email"
                                :error-messages="contactPersonForm.errors.email"
                                label="E-Mail"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                v-model="contactPersonForm.phone_number"
                                :error-messages="contactPersonForm.errors.phone_number"
                                label="Telefonnummer"
                              />
                            </v-col>
                            <v-col cols="12">
                              <v-select
                                v-model="contactPersonForm.branch"
                                :items="branches"
                                item-text="name"
                                :error-messages="contactPersonForm.errors.branch"
                                label="Standort"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-btn color="secondary" text @click="close">
                          abbrechen
                        </v-btn>
                        <v-spacer />
                        <v-btn
                          color="primary"
                          :loading="contactPersonForm.processing"
                          @click="save"
                        >
                          speichern
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item v-if="editedIndex != -1">
                    <v-card>
                      <v-card-text>
                        <v-list
                          subheader
                          one-line
                        >
                          <v-subheader>Standorte</v-subheader>
                          <v-list-item
                            v-for="branch in contactPersons.find(contactPerson => contactPerson.id == editedIndex).branches"
                            :key="branch.id"
                          >
                            <v-list-item-content>
                              <v-list-item-title>{{ branch.name }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog v-model="deleteDialog" max-width="500px">
            <v-card>
              <v-card-title
                class="headline"
              >
                Soll diese Kontakperson wirklich gelöscht werden?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn color="blue darken-1" text @click="closeDelete">
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  :loading="contactPersonForm.processing"
                  @click="deleteItemConfirm"
                >
                  OK
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template #[`item.form_of_address`]="{ item }">
        {{ item.form_of_address == "Mr." ? "Herr" : "Frau" }}
      </template>
      <template #[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
      <template #no-data>
        Keine Ansprechpartner gefunden.
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
export default {
   props: {
      contactPersons: {
         type: Array,
         required: true
      },
      branches: {
         type: Array,
         required: true
      },
      company: {
         type: Object,
         required: true
      },
   },
   data () {
      return {
         dialog: false,
         deleteDialog: false,
         editTab: 0,
         headers: [
            // { text: '#', value: 'id' },
            { text: 'Anrede', value: 'form_of_address' },
            { text: 'Vorname', value: 'first_name' },
            { text: 'Nachname', value: 'last_name' },
            { text: 'E-Mail', value: 'email.email' },
            { text: 'Telefon', value: 'phone_number.number' },
            { text: 'Actions', value: 'actions', sortable: false },
         ],
         editedIndex: -1,
         contactPersonForm: this.$inertia.form({
            form_of_address: null,
            first_name: null,
            last_name: null,
            notice: null,
            email: null,
            phone_number: null
         }),
      }
   },
   computed: {
      formTitle () {
         return this.editedIndex === -1 ? 'Ansprechpartner hinzufügen' : 'Ansprechpartner bearbeiten'
      },
   },

   watch: {
      dialog (val) {
         val || this.close()
      },
      deleteDialog (val) {
         val || this.closeDelete()
      },
      'contactPersonForm.recentlySuccessful' (val) {
         if (val) {
            this.close()
            this.closeDelete()
            this.reset()
         }
      },
   },
   methods: {
      editItem (item) {
         this.editedIndex = item.id

         this.contactPersonForm.form_of_address = item.form_of_address
         this.contactPersonForm.first_name = item.first_name
         this.contactPersonForm.last_name = item.last_name
         this.contactPersonForm.notice = item.notice
         this.contactPersonForm.email = item.email ? item.email.email : null
         this.contactPersonForm.phone_number = item.phone_number ? item.phone_number.number : null
         this.contactPersonForm.branch = item.branches[0]

         this.dialog = true
      },

      deleteItem (item) {
         this.editedIndex = item.id

         this.contactPersonForm.form_of_address = item.form_of_address
         this.contactPersonForm.first_name = item.first_name
         this.contactPersonForm.last_name = item.last_name
         this.contactPersonForm.notice = item.notice
         this.contactPersonForm.email = item.email ? item.email.email : null
         this.contactPersonForm.phone_number = item.phone_number ? item.phone_number.number : null

         this.deleteDialog = true
      },

      deleteItemConfirm () {
         this.$inertia.delete(this.route('contact_person.destroy', this.editedIndex))
         this.closeDelete()
      },

      close () {
         this.dialog = false
         this.$nextTick(() => {
            this.reset()
            this.editedIndex = -1
         })
      },

      closeDelete () {
         this.deleteDialog = false
         this.$nextTick(() => {
            this.reset()
            this.editedIndex = -1
         })
      },

      reset () {
         this.contactPersonForm.form_of_address = null
         this.contactPersonForm.first_name = null
         this.contactPersonForm.last_name = null
         this.contactPersonForm.notice = null
         this.contactPersonForm.email = null
         this.contactPersonForm.phone_number = null

         this.contactPersonForm.clearErrors()
      },

      save () {
         if (this.editedIndex > -1) {
            this.contactPersonForm.patch(
               this.route('contact_person.update', this.editedIndex)
            )
         } else {
            this.contactPersonForm.post(this.route('contact_person.store', this.company.id))
         }
      },
   },
}
</script>

<style>
</style>
